import React, { useEffect, useState } from "react";
import { BsFacebook } from "react-icons/bs";
import { IoLogoInstagram } from "react-icons/io";
import { FaWhatsapp, FaYoutube } from "react-icons/fa";
import { IoLogoTwitter } from "react-icons/io";
import { FaSnapchat, FaBasketballBall, FaGooglePlusG } from "react-icons/fa";
import axios from "axios";
import { Link } from "react-router-dom";
export const Footer3 = () => {
  const [footerColor, setFooterColor] = useState("#000");
  const [footerTextColor, setFooterTextColor] = useState("#fff");
  const [font, setFont] = useState("");
  const [themeColor, setThemeColor] = useState("#708090");
  const [themeIconColor, setThemeIconColor] = useState("#708090");
  const [socialLinks, setSocialLinks] = useState({});
  const [slogan, setSlogan] = useState("");
  const [contactDetails, setContactDetails] = useState(null);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);
  const accessToken = sessionStorage.getItem("accessToken");
  const appName = sessionStorage.getItem("appName");

  useEffect(() => {
    const fetchCategories = async () => {
      const formData = new FormData();
      formData.append("admin_auto_id", sessionStorage.getItem("admin_auto_id"));
      formData.append("app_type_id", sessionStorage.getItem("app_type_id"));

      try {
        const response = await axios.post(
          "https://gruzen.in/GrobizEcommerceAppBuilder/api/get_main_category_list",
          formData
        );

        if (response.data.status === 1) {
          setCategories(response.data.getmain_categorylist);
          console.log();
        }
      } catch (error) {
        setError("Error fetching data");
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setFooterColor(parsedStyle.footer_color);
      setFooterTextColor(parsedStyle.footer_text_color);
      setFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setSocialLinks({
        facebook: parsedStyle.facebook_link || "https://facebook.com",
        twitter: parsedStyle.twitter_link || "https://twitter.com",
        instagram: parsedStyle.instagram_link || "https://instagram.com",
        pinterest: parsedStyle.pinterest_link || "https://pinterest.com",
        linkedin: parsedStyle.linkedin_link || "https://linkedin.com",
        youtube: parsedStyle.youtube_link || "https://youtube.com",
        whatsapp: parsedStyle.whatsapp_link || "https://web.whatsapp.com/",
        appleStore:
          parsedStyle.apple_store_link ||
          "https://apps.apple.com/in/app/apple-store/id375380948?mt=8&mnid=sfo291LJq-dc_mtid_187079nc38483_pcrid_731945015408_pgrid_109516736059_pntwk_g_pchan__pexid_195442770243_ptid_kwd-12522920_&cid=aos-IN-kwgo-brand--slid-FER4pAmp--product-&mtid=187079nc38483&aosid=p238",
        playStore:
          parsedStyle.play_store_link ||
          "https://play.google.com/store/games?hl=en&pli=1",
        snapchat: parsedStyle.snapchat_link,
        dribble: parsedStyle.dribble_link,
        googlePLus: parsedStyle.google_plus_link,
      });
      setSlogan(parsedStyle.slogan);
    }
  }, []);

  useEffect(() => {
    const fetchContactDetails = async () => {
      const formData = new FormData();
      formData.append("admin_auto_id", sessionStorage.getItem("admin_auto_id"));

      try {
        const response = await axios.post(
          "https://gruzen.in/GrobizEcommerceAppBuilder/api/Show-Contact-Details",
          formData
        );

        if (response.data.status === 1) {
          setContactDetails(response.data.allcontact_details[0]);
        }
      } catch (error) {
        setError("Error fetching data");
      }
    };

    fetchContactDetails();
  }, []);

  return (
    <footer
      className={`py-8 mb-12 lg:mb-0 px-6 text-sm ${font}`}
      style={{ backgroundColor: footerColor, color: footerTextColor }}
    >
      {/* <div>
        <div className="flex justify-center gap-4 mt-4 mb-4">
          <div className="p-2 bg-gray-100 rounded-lg focus:outline-none w-96">
            <p className="font-bold text-gray-400 ">
              Enter Your Email Address
            </p>
          </div>
          <button
            className="w-20 p-3 font-bold rounded-lg "
            style={{
              color: footerTextColor,
              opacity: 1,
              backgroundColor: themeColor,
            }}
            onMouseEnter={(e) => (e.target.style.opacity = 0.7)}
            onMouseLeave={(e) => (e.target.style.opacity = 1)}
          >
            Send
          </button>
        </div>
      </div> */}

      <div className="grid grid-cols-1 gap-2 mx-auto max-w-7xl md:grid-cols-6">
        {/* Logo and Tagline */}
        <div className="col-span-2 mt-3">
          <h2
            className="text-2xl font-bold "
            style={{ color: footerTextColor }}
          >
            {appName}
          </h2>
          <p className="mt-2 font-bold">{slogan}</p>
        </div>

        {/* Tira Links */}
        <div>
          <h6 className="font-bold">{appName}</h6>
          <div className="grid mt-3 space-y-2">
            <Link
              to="/aboutus"
              className=" text-decoration-none"
              style={{ color: footerTextColor }}
            >
              About Us
            </Link>
            {/* <Link
              to="/privacyandpolicy"
              className=" text-decoration-none"
              style={{ color: footerTextColor }}
            >
              Privacy Policy
            </Link>
            <Link
              to="/termsandcondition"
              className=" text-decoration-none"
              style={{ color: footerTextColor }}
            >
              Terms and Conditions
            </Link> */}

            {accessToken && (
              <Link
                to={{
                  pathname: "/dashboard",
                }}
                state={{ page: "myorders" }}
                className=" text-decoration-none"
                style={{ color: footerTextColor }}
              >
                Track Order
              </Link>
            )}
          </div>
        </div>

        {/* Customer Care */}
        <div>
          <h6 className="font-bold">Customer Care</h6>
          <div className="grid mt-3 space-y-2">
            <Link
              to="/contact"
              className="text-decoration-none"
              style={{ color: footerTextColor }}
            >
              Contact Us
            </Link>
            <Link
              to="/faq"
              className=" text-decoration-none"
              style={{ color: footerTextColor }}
            >
              FAQs
            </Link>
          </div>
        </div>

        {/* Categories */}
        <div>
          <h6 className="font-bold">Categories</h6>
          <div className="grid mt-3 space-y-2">
            {error ? (
              <p>{error}</p>
            ) : (
              categories.slice(0, 5).map((category) => (
                <Link
                  key={category._id}
                  to={`/maincategory/${category.category_auto_id}`}
                  className="text-decoration-none text-inherit "
                >
                  {category.category_name}
                </Link>
              ))
            )}
          </div>
        </div>

        {/* Contact & Footer Links */}
        <div className="">
           {contactDetails && (
            <>
          <h6 className="mb-3 font-bold ">Contact Us</h6>
         
            
              <p className="font-bold">
                Call:{" "}
                <span className="font-bold " style={{ color: footerTextColor }}>
                  {contactDetails.contact}
                </span>
              </p>
              <p className="font-bold">
                Whatsapp:{" "}
                <span className="font-bold " style={{ color: footerTextColor }}>
                  {contactDetails.contact}
                </span>
              </p>
            
              <p className="font-bold">
                Email:{" "}
                <a
                  href={`mailto:${contactDetails.email}`}
                  className="no-underline hover:underline"
                  style={{ color: footerTextColor }}
                >
                  {contactDetails.email}
                </a>
              </p>
            </>
           )}
        </div>
      </div>

      <div className="pt-4 pb-10 mt-4 text-xs text-gray-500 border-t md:mr-10">
        <p className="text-sm text-black">© 2025 {appName}. All Rights Reserved.</p>
        <div className="flex justify-between mt-10 mb-10 text-2xl float-end">
          {socialLinks.facebook && (
            <i className="p-2 ">

              <a
                href={socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
              >
                <BsFacebook style={{ color: themeIconColor }} />
              </a>
            </i>
          )}
          {socialLinks.instagram && (
            <i className="p-2">
              <a
                href={socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
              >
                <IoLogoInstagram style={{ color: themeIconColor }} />
              </a>
            </i>
          )}

          {socialLinks.youtube && (
            <i className="p-2">
              <a
                href={socialLinks.youtube}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube style={{ color: themeIconColor }} />
              </a>
            </i>
          )}
          {socialLinks.twitter && (
          <i className="p-2">
            <a
              href={socialLinks.twitter}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IoLogoTwitter style={{ color: themeIconColor }} />
            </a>
          </i>
          )} 
          {socialLinks.dribble && (
          <i className="p-2">
            <a
              href={socialLinks.dribble}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaBasketballBall style={{ color: themeIconColor }} />
            </a>
          </i>
          )}
          {socialLinks.whatsapp && (
          <i className="p-2">
            <a
              href={socialLinks.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp style={{ color: themeIconColor }} />
            </a>
          </i>
          )}

          {socialLinks.snapchat && (
          <i className="p-2">
            <a
              href={socialLinks.snapchat}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaSnapchat style={{ color: themeIconColor }} />
            </a>
          </i>
          )}

          {socialLinks.googlePLus && (
          <i className="p-2">
            <a
              href={socialLinks.googlePLus}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGooglePlusG style={{ color: themeIconColor }} />
            </a>
          </i>
          )}
        </div>
        <div
          className="flex mt-2 space-x-4 "
          style={{ color: footerTextColor }}
        >
          <Link
            className="text-decoration-none text-inherit hover:underline"
            to="/termsandcondition"
          >
            Terms and Conditions
          </Link>
          <Link
            className="text-decoration-none text-inherit hover:underline"
            to="/privacyandpolicy"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer3;
